import env from '../../env';
import { getTimeDiffString } from '../../util';

const DISABLE_IOS_DOWNLOAD_LINK = false;
const DISABLE_WINDOWS_DOWNLOAD_LINK = false;
const DISABLE_ANDROID_DOWNLOAD_LINK = false;

class AppVersionLabelController {
  constructor(
    $interval,
    $scope,
    $translate,
    $window,
    DEBUG,
    AppVersionService,
    DataSyncService,
    LogService
  ) {
    "ngInject";
    this.$interval = $interval;
    this.$scope = $scope;
    this.$translate = $translate;
    this.$window = $window;
    this.DEBUG = DEBUG;
    this.AppVersionService = AppVersionService;
    this.DataSyncService = DataSyncService;
    this.LogService = LogService;
  }

  $onInit() {
    const delay = 1000 * 60;
    this.$interval(() => {
      // No-op to update scope
    }, delay);
  }

  get appVersion() {
    return this.AppVersionService.appVersion;
  }

  get appNameTranslationKey() {
    return this.AppVersionService.appNameTranslationKey;
  }

  get shortVersionInfo() {
    return this.AppVersionService.shortAppVersionInfo;
  }

  get fullVersionInfo() {
    return this.AppVersionService.extendedAppVersionInfo;
  }

  get showCheckForUpdate() {
    return this.DataSyncService.isOnline;
  }

  get showAndroidDownloadLink() {
    if (DISABLE_ANDROID_DOWNLOAD_LINK) {
      return false;
    }
    return this.AppVersionService.isAndroid && !this.AppVersionService.isCordova;
  }

  get showIOSDownloadLink() {
    if (DISABLE_IOS_DOWNLOAD_LINK) {
      return false;
    }
    return this.AppVersionService.isIOS && !this.AppVersionService.isCordova;
  }

  get showWindowsDownloadLink() {
    if (DISABLE_WINDOWS_DOWNLOAD_LINK) {
      return false;
    }
   return this.AppVersionService.isWindows && !this.AppVersionService.isCordova;
  }

  checkForUpdate() {
    this.$scope.$emit('checkForUpdate');
  }

  openAndroidDownloadPage() {
    this.AppVersionService.openAndroidDownloadPage();
  }

  openIOSDownloadPage() {
    this.AppVersionService.openIOSDownloadPage();
  }

}

export default AppVersionLabelController;
